var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 67,
    viewBox: "0 0 100 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 287 175"
  }, /*#__PURE__*/React.createElement("image", {
    width: 287,
    height: 175,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAR8AAACvCAMAAADzNCq+AAADAFBMVEX///8ANYEAIXjFytoAHXcAJ3vX2+WZo78ALX3a3uelrsZ1hKvKz90AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACaCXd3AAAARGVYSWZNTQAqAAAACAABh2kABAAAAAEAAAAaAAAAAAADoAEAAwAAAAEAAQAAoAIABAAAAAEAAAEfoAMABAAAAAEAAACvAAAAAI8SawMAAAIsSURBVHgB7dxBboNAFAVBSEKMndz/vLlBWSP9RQTNtm2Qircdtm32+v7aV67jMfv4f3+3fPyK8snHAq7tJx8LuLaffCzg2n7ysYBr+8nHAq7tJx8LuLaffCzg2n7ysYBr+8nHAq7tJx8LuLaffCzg2n7ysYBr+8nHAq7tJx8LuLaffCzg2n7ysYBr+8nHAq7tJx8LuLaffCzg2n7ysYBr+8nHAq7tJx8LuLaffCzg2n7ysYBr+8nHAq7tJx8LuLaffCzg2n7ysYBr+8nHAq7tJx8LuD6v9v2Wz9nrdax83mY/f35nnz99t+1j9lrj2fdz9vHjd9uWXvf9fpyP33k++VjAtf3kYwHX9pOPBVzbTz4WcG0/+VjAtf3kYwHX9pOPBVzbTz4WcG0/+VjAtf3kYwHX9pOPBVzbTz4WcG0/+VjAtf3kYwHX9pOPBVzbTz4WcG0/+VjAtf3kYwHX9pOPBVzbTz4WcG0/+VjAtf288Rk+8XK58zvDB6Yud/7LxwGX6+XODy4L+A+dz83HAq7tJx8LuLaffCzg2n7ysYBr+8nHAq7tJx8LuLaffCzg2n7ysYBr+8nHAq7tJx8LuLaffCzg2n7ysYBr+8nHAq7tJx8LuLaffCzg2n7ysYBr+8nHAq7tJx8LuLaffCzg2n7ysYBr+8nHAq7tJx8LuLaffCzg2n7ysYBr+8nHAq7tJx8LuLaffCzg2n7ysYBr+8nHAq7tJx8LuLafe/n8AVYPXehiVQPgAAAAAElFTkSuQmCC"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1db65b68f5a5f70a63217b84e0262bcc",
    "data-name": "1db65b68f5a5f70a63217b84e0262bcc",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "url(#pattern)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 67,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 99.5,
    height: 66.5,
    rx: 4.75,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinland);
export default __webpack_public_path__ + "static/media/finland.a3012b2ae924cf660efe529c9aa04d35.svg";
export { ForwardRef as ReactComponent };